export default "/assets/trash-can-gray-outline.svg";